import { render } from "./NotificationsItem.vue?vue&type=template&id=15d34359&scoped=true"
import script from "./NotificationsItem.vue?vue&type=script&lang=js"
export * from "./NotificationsItem.vue?vue&type=script&lang=js"

import "./NotificationsItem.vue?vue&type=style&index=0&id=15d34359&lang=scss"
import "./NotificationsItem.vue?vue&type=style&index=1&id=15d34359&scoped=true&lang=scss"
import "./NotificationsItem.vue?vue&type=style&index=2&id=15d34359&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d34359"]])

export default __exports__